import gql from 'graphql-tag';

const GET_NOTIFICATIONS = gql`
  query notifications($userId: ID!, $first: Int, $skip: Int) {
    notifications(
      where: { user: { id: $userId } }
      orderBy: createdAt_DESC
      first: $first
      skip: $skip
    ) {
      id
      message
      type
      featureID
      createdAt
    }
  }
`;

export default GET_NOTIFICATIONS;
